import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=6951af5e"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6951af5e')) {
      api.createRecord('6951af5e', component.options)
    } else {
      api.reload('6951af5e', component.options)
    }
    module.hot.accept("./Doc.vue?vue&type=template&id=6951af5e", function () {
      api.rerender('6951af5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Doc.vue"
export default component.exports